import Vue from "vue";
import {
  Button,
  ButtonGroup,
  Popover,
  Menu,
  Radio,
  RadioButton,
  RadioGroup,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Select,
  Option,
  Pagination,
  Table,
  TableColumn,
  Switch,
  Dialog,
  Loading,
  Form,
  FormItem,
  Input,
  Tabs,
  TabPane,
  Tree,
  TimePicker,
  DatePicker,
  upload,
  Progress,
  Image,
  Tag,
  Col,
  inputNumber,
  Message,
  MessageBox,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  TimeSelect,
  CheckboxButton,
  Link,
} from "element-ui";

import { Icon, tableList, UploadFile, CusRemoteSelect, EnumSelect } from "_c";

Vue.use(Button);
Vue.use(CheckboxButton);
Vue.use(ButtonGroup);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Popover);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tree);
Vue.use(upload);
Vue.use(DatePicker);
Vue.use(Progress);
Vue.use(Image);
Vue.use(Tag);
Vue.use(inputNumber);
Vue.use(Cascader);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(TimePicker);
Vue.use(TimeSelect);
Vue.use(Row);
Vue.use(Col);
Vue.use(Link);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.component("el-icon", Icon);
Vue.component("el-col", Col);
Vue.component("el-table-list", tableList);
Vue.component("upload-file", UploadFile);
Vue.component("cus-remote-select", CusRemoteSelect);
Vue.component("enum-select", EnumSelect);
/**
 *
 */
import "quill/dist/quill.snow.css";
Vue.component("quill-editor", () => import(/* webpackChunkName: "back" */ "_c/vue-quill"));

/**
 *
 *
 */
import Calc from "better-calc";
Vue.prototype.$calc = {
  div: (a, b) => Calc.div(Number(a), Number(b)),
  mul: (a, b) => Calc.mul(Number(a), Number(b)),
  add: (a, b) => Calc.add(Number(a), Number(b)),
  sub: (a, b) => Calc.sub(Number(a), Number(b)),
};
